/**
 * 入力文字列が整数値に変換可能な文字列かどうか確認します。
 *
 * @param {string} value 文字列
 * @returns {boolean} 整数値に変換可能な場合は `true` 、それ以外の場合は `false`
 */
export function isToInt(value) {
    return !!value.match(/^[0-9０-９,，]+$/);
}

/**
 * 入力文字列を整数値に変換します。
 *
 * @param {string} value 文字列
 * @returns {number}
 */
export function toInt(value) {
    const removeCommmaValue = value.replace(/,/g, '');
    const halfWidthValue = toHalfWidth(removeCommmaValue);
    return Number.parseInt(halfWidthValue);
}

/**
 * 全角⇒半角に変換（英数字、カンマ対応）
 *
 * @param {string} str 入力文字列
 * @returns {string}
 */
export function toHalfWidth(str) {
    return str.replace(/[Ａ-Ｚａ-ｚ０-９，]/g, (s) => {
        // 変換前の文字コードを取得
        const code = s.charCodeAt(0);
        // 全角文字のコード範囲を調整して半角に
        return String.fromCharCode(code - 0xFEE0);
    });
}
